const state = () => {
    return {
      fertilityProducts:[],
      fertilityProductsLight:[]
    }
  }
  
  export default state;
  